module.exports = __webpack_public_path__ + "media/images/lp/1/voice1-close-9c24b8287f8fc721dce45a7f9d926246.png";